export default "__VITE_ASSET__BtMOsHB$__"